import { Comment as CommentType } from '~/lib/discussions/types';
import { Button } from '~/components/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useComment } from '~/lib/discussions/useComment';

export const Buttons = ({
  comment,
  mutateComment,
}: {
  comment: CommentType;
  mutateComment: () => void;
}) => {
  const { like } = useComment(comment, mutateComment);

  // TODO: Add missing helpful and reply functionality
  return (
    <div className="mt-4 flex justify-end gap-x-2">
      <Button tertiary size="small" onClick={like}>
        <div className="flex items-center gap-x-1">
          <FontAwesomeIcon icon={faChevronUp} />
          <span>Helpful {comment.num_likes}</span>
        </div>
      </Button>
      <Button size="small">Reply</Button>
    </div>
  );
};
